import { Grid, Typography } from "@mui/material";
import HardwareSupportDisplay from "./HardwareSupportDisplay";
import SoftwareSupportDisplay from "./SoftwareSupportDisplay";

const Support = () => {
  return (
    <Grid container direction="column" spacing={2} alignItems="flex-start">
      <Grid container item spacing={2} alignItems="center">
        {" "}
        <Grid item>
          <img
            src={`${process.env.PUBLIC_URL}\\LPTIconSmall.webp`}
            alt="LP Tech Logo"
            height="80px"
          />
        </Grid>
        <Grid item>
          <Typography variant="h2">Support Links</Typography>
        </Grid>
      </Grid>
      <Grid item container spacing={9}>
        <Grid item>
          <HardwareSupportDisplay />
        </Grid>
        <Grid item>
          <SoftwareSupportDisplay />
        </Grid>
      </Grid>
      <Grid item>
        <img
          src={`${process.env.PUBLIC_URL}\\SX500Intro.jpg`}
          alt="SX5000 display"
          height="350px"
        />
      </Grid>
    </Grid>
  );
};

export default Support;
